import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

import locale from 'locale';
import api from 'api';
import type Department from 'types/department';

import { Wrapper, Description, ButtonGroup } from 'components/lib/Modal/styled';
import Button from 'components/lib/Button';

export default ({ setModalVisible, department }: {
  setModalVisible: (b: boolean) => void,
  department: [Department | undefined, (d?: Department) => void]
}) => {
  /**
   * Hooks
   */
  const queryClient = useQueryClient();

  const mutation = useMutation(api.department.delete, {
    onSuccess: () => {
      queryClient.invalidateQueries(api.department.queryKey);

      const message = locale.en.toastMessages.deleteSuccess.replace("{{ 1 }}", department[0]?.name || '');
      toast.success(message);
      department[1](undefined);
      setModalVisible(false);
    }
  });

  /**
   * Not hook
   */
  const handleCancelClick = () => { setModalVisible(false) }

  const handleDeleteClick = () => { department[0]?.id && mutation.mutate(department[0].id) }

  let description = locale.en.settings.department.deleteDesc;
  if (department[0]) { description = description.replace('{{ 1 }}', department[0].name) }

  /**
   * Render
   */
  return (
    <Wrapper>
      <Description>
        {description}
      </Description>

      <ButtonGroup>
        <Button.Ghost onClick={handleCancelClick}>
          {locale.en.common.button.cancel}
        </Button.Ghost>

        <Button.Classic onClick={handleDeleteClick}>
          {locale.en.common.button.delete}
        </Button.Classic>
      </ButtonGroup>
    </Wrapper>
  );
}